/**
 * Created by Michal on 11.04.2017.
 */
global.$ = global.jQuery = require('jquery');

var moment = require('moment');

(function (Render, $, undefined) {

    //Public Method
    Render.renderNumber = function (x, toFixed) {
        if (x === 0) {
            return 0;
        }
        if (toFixed === undefined) {
            toFixed = 2;
        }
        if (x) {
            return parseFloat(x).toFixed(toFixed).toString().replace(/\B(?=(\d{3})+(?!\d))/g, "&nbsp;").replace('.', ',');
        }
    };

    Render.formatNumber = function (x, toFixed, before = '', after = '') {
        return '<span class="text-right" style="display: block;">' + before + this.renderNumber(x, toFixed) + after;
    };

    Render.renderDateToFormat = function (date, format) {
        return moment(date).format(format);
    };

    Render.renderDateSpecial = function (date, validate) {

        if (validate === true) {
            if (moment().isSame(moment(date, "YYYY.MM.DD"), 'day')) {
                return "<span class='date-today'>" + Render.renderDateToFormat(date, 'DD.MM') + '<span class="hy">.' + Render.renderDateToFormat(date, 'YYYY') + "</span></span>";
            } else if (moment().add(1, 'day').isSame(moment(date, "YYYY.MM.DD"), 'day')) {
                return "<span class='date-tomorrow'>" + Render.renderDateToFormat(date, 'DD.MM') + '<span class="hy">.' + Render.renderDateToFormat(date, 'YYYY') + "</span></span>";
            } else if (moment(date, "YYYY.MM.DD").isBetween(moment(), moment().add(7, 'days'))) {
                return "<span class='date-this-week'>" + Render.renderDateToFormat(date, 'DD.MM') + '<span class="hy">.' + Render.renderDateToFormat(date, 'YYYY') + "</span></span>";
            } else if (moment().isAfter(moment(date, "YYYY.MM.DD"))) {
                return "<span class='date-after'>" + Render.renderDateToFormat(date, 'DD.MM') + '<span class="hy">.' + Render.renderDateToFormat(date, 'YYYY') + "</span></span>";
            }
        }

        return Render.renderDateToFormat(date, 'DD.MM') + '<span class="hy">.' + Render.renderDateToFormat(date, 'YYYY') + "</span></span>";
    };

    Render.renderUserName = function (user) {
        let result = '<a href="' + laroute.route('users.show', {user: user.id}) + '">';

        let full_name = user.full_name.split(" ");
        result += '<span class="text-nowrap" title="' + user.full_name + '">' + full_name[0] + " " + (full_name[1] ? full_name[1].charAt(0) : '') + '</span>';

        result += '</a>';
        return result;
    };

    Render.check = function (isOk) {
        if (isOk) {
            return '<span class="ion ion-android-checkmark-circle"></span>'
        } else {
            return '<span class="ion ion-close-circled"></span>'
        }
    }

}(window.Render = window.Render || {}, jQuery));

(function (Base, $, undefined) {

    //Public Method
    Base.IsJsonString = function (str) {
        try {
            JSON.parse(str);
        } catch (e) {
            return false;
        }
        return true;
    };

}(window.Base = window.Base || {}, jQuery));


(function (VisiModal, $, undefined) {

    //Public Method
    VisiModal.changeModal = function (a, method) {

        $.ajax({
            url: $(a).attr('href'),
            type: (method ? method : 'GET'),
            dataType: 'multipart/form-data',
            processData: false,
            contentType: false
        })
            .always(function (data) {

                $("#modal").find('.modal-content').html(data.responseText);
                $("#modal").modal({show: true});

            });

        return false;
    };

    var _targetVisiModal = null;

    VisiModal.close = function(){
        if(_targetVisiModal){
            _targetVisiModal.modal('hide');
            _targetVisiModal = null;
        }
    };

    VisiModal.modalCallback = function (response) {

        // if (!response.error) {

        if(_targetVisiModal){
            _targetVisiModal.modal('hide');
            _targetVisiModal = null;
        }

        VisiApp.redrawDataTables();

        if (response.redirect) {
            location.href = response.redirect;
        }

        // } else {
        //
        //     console.log('some error', response);
        //     if (Array.isArray(response.error)) {
        //         _targetVisiModal.find('.modal-error').html(response.error.join('<br>'));
        //     } else {
        //         _targetVisiModal.find('.modal-error').html(response.error);
        //     }
        //
        // }

    };

    VisiModal.changeModalWithForm = function(form, method, action){

        var formData = new FormData(form[0]);

        $.ajax({
            url: (action ? action : form.attr('action')),
            data: formData,
            type: (method ? method : 'GET'),
            dataType: 'multipart/form-data',
            processData: false,
            contentType: false
        })
            .always(function (data) {

                $("#modal").find('.modal-content').html(data.responseText);
                $("#modal").modal({show: true});

            });
    };

    VisiModal.showModal = function (href) {

        _targetVisiModal = $("#modal");

        $.ajax({
            url: href,
            type: 'GET',
            dataType: 'multipart/form-data',
            processData: false,
            contentType: false
        })
            .always(function (data) {

                if(data.status === 200){
                    _targetVisiModal.find('.modal-content').html(data.responseText);
                    _targetVisiModal.modal({show: true});

                    // VisiApp.initSimplePickerWithTime($("#modal").find('.date-picker'));
                } else {
                    _targetVisiModal.find('.modal-content').html("Whoops, looks like something went wrong.");
                    _targetVisiModal.modal({show: true});
                }


            });

        return false;

    };

}(window.VisiModal = window.VisiModal || {}, jQuery));





// WEBPACK FOOTER //
// ./resources/assets/js/app/functions.js